// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"8660172e","556":"8660172e","1008":"8660172e","1796":"8660172e","2040":"92f336f2","7584":"8660172e","9864":"8660172e"}[chunkId] + ".chunk.css";
};